import styled from "styled-components";

export const StyledReturnCart = styled.div`
  .select {
    font-size: 14px;
    color: #3B444D;
    font-weight: 700;
    margin-left: 1rem;
    margin-bottom: 10px;
  }

  .return-request {
    padding: 15px;
    box-shadow: 0px -10px 20px 0px rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 100%;
    z-index: 7;
    background: #fff;
    bottom: 25px;

    .product-number {
      font-size: 14px;
    }

    .payment-form-mob {
      position: relative;
      p {
        position: absolute;
        font-size: 10px;
        top: -5px;
        left: 2px;
        letter-spacing: 1px;
      }
      fieldset {
        border: none;
      }
      .MuiSelect-select {
        padding: 10px 30px 10px 2px;
        border: none;
      }
    }
  }

  .mobile-request-consent-label, .desktop-request-consent-label{
    margin: 10px 0px;
    display: flex;,
    align-items: ;center;
  }

  .desktop-request-consent-label{
    display: none;
  }

  .request-button {
    border-radius: ${(props) => (props.sharpEdge ? "0px" : "4px")};
    padding: 10px;
    font-weight: 700;
    font-size: 12px;
    text-transform: capitalize;
    width: 100%;
  }

  .help {
    font-weight: 700;
    font-size: 12px;
    color: var(--color-primary);
    margin: 0px 20px 100px;
    text-decoration: underline;
  }

  .overlay {
    position: fixed;
    height: 100vh;
    bottom: 0px;
    background: #fff;
    width: 100%;
    z-index: 99;
    opacity: 0.6;
  }

  .pricing {
    margin-left: 20px !important;
  }

  @media (min-width: 800px) {
    .select {
      display: flex;
      padding-left: 11%;
      font-size: 18px;
      margin-left: 0px;
    }
    .pricing {
      margin-left: 0px !important;
    }
    .return-request {
      padding: 100px 5.5% 20px;
      top: 0;
      bottom: initial;
      display: none;
      font-size: 20px;
      max-width: 1920px;
      box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);

      .product-number {
        font-size: 20px;
      }
    }
    .mobile-request-consent-label{
      display: none;
    }
    .desktop-request-consent-label{
      display: flex;
    }
    .request-button {
      padding: 1rem;
      margin-left: 0px;
      font-size: 14px;
      width: 100%;
      display: block;
    }
    .help {
      margin: 20px 0;
    }
    .overlay {
      top: 80px;
      bottom: initial;
    }
  }
`;

export const StyledExchange = styled.div`
  padding: ${(props) =>
    props.location === "/success" ? "30px 0px" : "60px 0px"};
  position: relative;

  .cart-wrapper {
    .exchange-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;

      .return-item-box {
        margin-top: 0.5rem;
      }

      .exchange-box {
        display: flex;
        padding: 0px 0px;
        border-radius: 4px;
        flex-direction: row;
        flex: 0.45;

        .details {
          margin-left: 1rem;
        }

        .return-label {
          font-size: 12px;
          color: #fff;
          position: absolute;
          top: -1rem;
          right: -1rem;
          padding: 2px 10px 4px;
          border-top-right-radius: 8px;
          border-bottom-left-radius: 8px;
        }

        .upto-refund,
        .conditions {
          font-size: 12px;
        }

        .image-preview-container {
          width: 100%;
          max-width: 60px;
          height: 60px;
          overflow: hidden;
          margin-top: 10px;
        }

        .image-preview {
          width: 100%;
          height: 100%;
          object-fit: contain;
          border-radius: 4px;
        }

        .description,
        .quantity {
          font-size: 16px;
          margin: 7px 0;
          color: #3B444D;
        }

        .title,
        .price {
          font-size: 16px;
          margin: 7px 0;
          font-weight: 700;
          color: ${(props) => props.primaryColor};
        }

        .price {
          color: #3B444D;
        }

        .stock {
          color: red;
          margin-left: auto;
        }
      }

      .return-icon {
        display: flex;
        align-items: center;
        flex: 0.1;
        margin: 10px 0px;
        justify-content: center;
        height: 100%;

        svg {
          position: absolute;
          top: -14px;
        }
      }
    }

    .return-type,
    .return-reason {
      font-size: 16px;
    }
  }

  .pickup-address-web {
    display: none;
  }

  .pricing-padding {
    padding: 0px 16px;
    font-size: 1rem;
  }

  .shipping-address-details {
    font-size: 12px;
    background: #d9eafe;
    color: #4273eb;
    border-bottom: 1px solid #11111133;
    font-weight: 500;
    margin-bottom: 10px;
    padding: 0.75rem;
  }

  .price-details {
    padding: ${(props) =>
      props.location === "/return-cart" ? "20px 0px 0px" : "20px 0px"};
    flex-direction: column;
    display: flex;
    width: 100%;
    color: #333;
    position: relative;
    background: #fff;

    .request-button {
      display: none;
    }

    #Returnmode {
      border-bottom: ${(props) =>
        props.refundModeError ? "1px solid red" : "none"};
    }

    .box {
      border-radius: 4px;
      padding: ${(props) =>
        props.location === "/tracking" ? "0px" : "0px 20px"};
      background: #fff;
      margin: 0px 0px;
      width: 100%;

      .title {
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        color: ${(props) => props.primary_color};
      }

      .MuiButtonBase-root.MuiRadio-root {
        padding: 5px 9px;
      }

      .know {
        font-size: 12px;
      }

      .refund-preference-title {
        font-size: 16px;
      }

      .radio-label,
      .refund-preference,
      .refund-note {
        font-size: 13px;
      }
    }

    .address {
      padding: ${(props) =>
        props.location === "/success" ? "0px 1.25rem" : "0px !important"};
    }
  }

  .pricing {
    font-size: 16px;
    margin: 0px 20px 20px;
  }

  .product-details {
    width: 100%;
    color: #333333;
    font-weight: 500;
    font-size: 1rem;
    margin: ${(props) =>
      props.location === "/return-cart"
        ? "0px 20px 20px"
        : props.location === "/tracking"
        ? "0px"
        : "1rem"};
  }

  .products-return {
    .accordion {
      border-radius: 0px;
      .MuiAccordionDetails-root {
        padding: 0px;
      }
    }
  }

  @media (min-width: 800px) {
    padding: ${(props) =>
      props.location === "/success" ? "30px 120px 0px" : "120px 0px 0px"};
    display: flex;

    .products-return,
    .price-details {
      min-width: 0;
      box-sizing: border-box;
    }

    .product-details {
      margin: ${(props) => props.location !== "/return-cart" && "1rem 0px"};
      font-size: ${(props) => props.location !== "/return-cart" && "18px"};
    }
    .products-return {
      flex: 0.5;
      padding-bottom: 25px;

      .accordion {
        margin-left: 11%;
        margin-right: 0;
      }

      .product-display {
        padding: ${(props) =>
          props.returnedProducts !== undefined &&
          props.returnedProducts.length > 0
            ? "25px 0px 0px 0px"
            : "2px 0px 0px 10%"};
      }
    }

    .pickup-address-web {
      display: block;
    }

    .pricing-padding {
      padding: 0px;
      font-size: 1.25rem;
    }

    .cart-wrapper {
      border-bottom: ${(props) =>
        props.outOfStock !== undefined &&
        props.outOfStock !== null &&
        props.returnedProducts
          .filter((a) => a.variant_id)
          .indexOf(props.outOfStock)
          ? `1px solid red`
          : "1px solid #11111133"};
      border-radius: 4px;

      .exchange-wrapper {
        flex-direction: row;

        .mob-ex-divider {
          display: none;
        }

        .return-item-box {
          margin-top: 0rem;
        }

        .exchange-box {
          flex: 0.45;
          flex-direction: column;
          .upto-refund,
          .conditions {
            font-size: 16px;
          }
          .details {
            padding: 0px 0px;
            position: relative;
            width: 100%;
            margin-left: 0;

            .title,
            .description,
            .quantity,
            .price {
              font-size: 16px;
              margin: 10px 0;
            }
          }
        }

        .return-icon {
          margin: 0 1rem;
          svg {
            position: relative;
            top: 0;
          }
        }
      }

      .return-type,
      .return-reason {
        font-size: 1rem;
      }
    }

    .pricing {
      align-items: start;
      font-size: 1.25rem;
      margin: 20px 0px 0px;
    }

    .shipping-address-details {
      font-size: 14px;
    }

    .price-details {
      padding: ${(props) =>
        props.location === "/return-cart"
          ? "0px clamp(24px, 4.5vw, 72px) 50px 4.5%"
          : "0px 5.5%"};
      visibility: ${(props) => (!props.webSelected ? "visible" : "hidden")};
      flex: 0.45;
      max-width: 55%;

      .request-button {
        display: block;
      }

      #Returnmode {
        border-bottom: ${(props) =>
          props.refundModeError ? "1px solid red" : "none"};
      }

      .box {
        justify-content: space-between;
        padding: 0px;
        .title {
          font-size: 18px;
          margin: 0px;
        }
        .MuiButtonBase-root.MuiRadio-root {
          padding: 9px;
        }
        .refund-preference-title {
          font-size: 18px;
        }
        .know,
        .radio-label,
        .refund-preference,
        .refund-note {
          font-size: 16px;
        }
      }

      .address {
        padding: 10px 0px !important;
        display: block;
      }
    }
  }
`;

export const StyledPaymentDiv = styled.div`
  background: #fff;
  padding: 20px;

  .payment-title {
    font-size: 16px;
    color: #3B444D;
    font-weight: 700;
    margin-bottom: 1rem;
  }

  .subtotal-statement {
    font-size: 16px;
    color: #3B444D;
  }

  @media (min-width: 800px) {
    padding: 10px 0px;
    .payment-title {
      font-size: 20px;
      margin-top: 0;
      margin-bottom: 1.25rem;
    }
  }
`;

export const StyledPaymentMode = styled.div`
  min-width: 100px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  margin-top: 10px;
  padding: 5px;
  font-size: 16px;
  border: ${(props) =>
    props.bonus ? "1px solid #16AC37" : `1px solid  ${props.primary_color}33`};
  background: ${(props) =>
    props.selected && props.bonus
      ? "rgb(22, 172, 55)"
      : props.selected && props.charges
      ? "rgb(241,65,108)"
      : props.selected
      ? props.primary_color
      : props.bonus
      ? "#e7fcf3"
      : "transparent"};
  color: ${(props) => (props.selected ? "#fff" : "")};

  :hover {
    background: ${(props) =>
      props.selected && props.bonus
        ? "rgb(22, 172, 55)"
        : props.selected && props.charges
        ? "rgb(241,65,108)"
        : props.selected
        ? props.primary_color
        : props.bonus
        ? "rgb(22, 172, 55, 0.25)"
        : `${props.primary_color}11`};
  }

  .handling-charges {
    background: #fdf5f8;
    color: #f1416c;
    padding: 0px 4px;
    font-size: 10px;
    border-top-right-radius: 4px;
    border-bottom-left-radius: 4px;
    width: fit-content;
    text-wrap: nowrap;
  }  
`;
